import { UntypedFormGroup } from "@angular/forms";

export const findInvalidControls = (form: UntypedFormGroup) =>
  [...Object.entries(form.controls)]
    .filter(([, control]) => control.invalid)
    .map(([name, control]) => ({name, errors: control.errors}));
